export default "__VITE_ASSET__CHlbALHM__"